<template>
  <v-dialog content-class="max-wrap" v-model="maxRegisterModalShow" width="700" persistent>
    <v-card>
      <v-card-title class="headline" primary-title>
        <div class="d-flex flex-fill">
          <div>
            <small>{{ $t('maxRegisterModal.title') }}</small>
          </div>
          <div class="ml-auto cursor" @click="close()">
            <v-icon>mdi-close</v-icon>
          </div>
        </div>
      </v-card-title>

      <hr />

      <v-card-text class="pa-4">
        <div class="mb-5">
          <div class="d-flex flex-column justify-center align-center">
            <img style="width: 60px;" :src="walletBg" alt="" />
            <span class="text-center my-5" style="font-size: 14px;max-width: 450px;">{{ $t('maxRegisterModal.desc') }}</span>
          </div>
          <div class="btn-box d-flex px-5">
            <v-btn
              @click="showDownloadModal"
              class="mb-2 mr-2"
              :class="{ 'btn-common-outline': !outline1, 'btn-common': outline1 }"
              height="50"
              x-large
              :large="$vuetify.breakpoint.xsOnly"
            >
              {{ $t('maxRegisterModal.agreeAndContinue') }}
            </v-btn>
            <v-btn
              @click="showDownloadModal2"
              class="mb-2"
              :class="{ 'btn-common-outline': !outline2, 'btn-common': outline2 }"
              height="50"
              x-large
              :large="$vuetify.breakpoint.xsOnly"
            >
              {{ $t('maxRegisterModal.registerWithoutKyc') }}
            </v-btn>
          </div>
        </div>
        <transition name="fade" mode="out-in" enter-active-class="slideInDown" leave-active-class="fadeOutBottom">
          <div v-show="maxWalletRegisterFlag" style="background: white">
            <p class="text-center mb-0 font-14">{{ $t('maxRegisterModal.scanQrCode') }}</p>
            <div class="text-center" style="margin:auto 0;">
              <v-progress-circular v-if="!qrString" indeterminate size="64"></v-progress-circular>
              <QrCode v-else :text="qrString" :qr-width="'170'" />
            </div>
            <div class="row bottom-section">
              <div class="col-12 col-sm-4 text-center">
                <img class="img-step" :src="imgStep1" />
                <div class="mb-20">{{ $t('max.register.step1') }}</div>
              </div>
              <div class="col-12 col-sm-4 text-center">
                <img class="img-step" :src="imgStep2" />
                <div class="mb-20">{{ $t('max.register.step2') }}</div>
              </div>
              <div class="col-12 col-sm-4 text-center">
                <img class="img-step" :src="imgStep3" />
                <div class="mb-20">{{ $t('max.register.step3') }}</div>
              </div>
            </div>
          </div>
        </transition>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import QrCode from '@/components/QrCode/QrCode';
import { mutationTypes } from '@/store/mutation-types';
import { MXWRegister } from 'mxw-register-sdk-web';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { maxRegisterApi } from '@/api/maxRegisterApi';
import { simpleCookie } from '@/common/js/simpleCookie';

export default {
  name: 'MaxRegister',
  components: {
    QrCode
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    pkgType: {
      type: String,
      required: true
    },
    large: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      walletBg: require('@/assets/images/home/max-wallet.png'),
      maxRegisterModalShow: false,
      maxWalletRegisterFlag: false,
      qrString: '',
      btnList: {
        max_ios_store: { icon: require('@/assets/images/home/grx_ios_store.svg'), path: '' },
        max_android_store: { icon: require('@/assets/images/home/grx_android_store.svg'), path: '' }
      },
      imgStep1: require('@/assets/images/account/max-register-step-1.png'),
      imgStep2: require('@/assets/images/account/max-register-step-2.png'),
      imgStep3: require('@/assets/images/account/max-register-step-3.png'),
      outline1: true,
      outline2: false,
      mxwRegisterUrl: window.env.mxwRegister.url,
      mxwRegisterPath: window.env.mxwRegister.path,
      layout: 1
    };
  },
  watch: {
    show: function(val) {
      this.maxRegisterModalShow = this.show;
      if (this.show && this.isConnected) {
        this.renderQrString();
      }
    },
    maxRegisterModalShow: function(val) {
      this.$emit('update:show', val);
    },
    isConnected: function(val) {
      if (this.show && this.isConnected) {
        this.renderQrString();
      }
    },
    withKyc: function(val) {
      this.renderQrString();
    }
  },
  computed: {
    ...mapGetters(['Getter_User_Info', 'getLoginPkgInfo', 'getRegisterPkgInfo', 'getPkgInfo'])
  },
  methods: {
    ...mapActions(['GET_USERINFO_ACTION', 'getMxwPkgInfo_action']),
    ...mapMutations([
      mutationTypes.SET_USERNAME,
      mutationTypes.SET_TOKEN,
      mutationTypes.SET_EXPIRETIME,
      mutationTypes.SET_LASTUPDATETIME
    ]),
    showDownloadModal() {
      this.maxWalletRegisterFlag = true;
      this.pkgType = 'REGISTER';
      this.withKyc = true;
      this.outline1 = true;
      this.outline2 = false;
      this.layout = 3;
      this.renderQrString();
    },
    showDownloadModal2() {
      this.maxWalletRegisterFlag = true;
      this.pkgType = 'REGISTER';
      this.withKyc = false;
      this.outline1 = false;
      this.outline2 = true;
      this.layout = 3;
      this.renderQrString();
    },
    loginWithMaxWallet(data) {
      maxRegisterApi.loginWithMaxWallet(data).then(response => {
        this.processLoginSuccess(response.data);
        this.$router.replace({ name: 'home' });
      });
    },
    registerWithMaxWallet(data) {
      let inviteCode = this.$route.query.inviteCode || null;

      maxRegisterApi.registerWithMaxWallet(data, inviteCode).then(response => {
        window.localStorage.setItem('firstLogin', 'true');
        this.processLoginSuccess(response.data);
        this.$router.replace({ name: 'home' });
      });
    },
    performKycWithMaxWallet(data) {
      maxRegisterApi.performKycWithMaxWallet(data).then(response => {
        if (!this.isUndefinedOrNullOrEmpty(response)) {
          this.$emit('update:show', false);
          this.processLoginSuccess(response.data);
          this.GET_USERINFO_ACTION();
        }
      });
    },
    redirectToRegister() {
      this.$emit('showRegisterForm');
    },
    processLoginSuccess(data) {
      simpleCookie.setItem('isLogin', true);

      // 以秒为单位
      this.SET_LASTUPDATETIME(new Date().getTime() / 1000);
      // this.SET_EXPIRETIME(data.expire);
      this.SET_EXPIRETIME(new Date().getTime() + 100000);
      this.SET_TOKEN(data.accessToken);
      this.SET_USERNAME(data.userName);

      this.GET_USERINFO_ACTION();
      this.successNotify(this.$t('login.success'));
    },
    async renderQrString() {
      if (this.isEmpty(this.getPkgInfo)) {
        await this.getMxwPkgInfo_action();
      }

      switch (this.pkgType) {
        case 'LOGIN':
          this.qrString = JSON.stringify(this.mxwRegister.signOn());
          break;
        case 'REGISTER':
          this.qrString = this.withKyc
            ? JSON.stringify(this.mxwRegister.signUp(this.getPkgInfo.rk))
            : JSON.stringify(this.mxwRegister.signUp(this.getPkgInfo.r));
          // r = register without kyc data, rk = register with kyc data, k: kyc only
          break;
        case 'GET_KYC':
          this.qrString = JSON.stringify(this.mxwRegister.signUp(this.getPkgInfo.k));
          break;
      }
    },
    close() {
      this.$emit('showRegisterForm');
    }
  },
  async mounted() {
    await this.getMxwPkgInfo_action();
    this.maxRegisterModalShow = this.show;
    this.mxwRegister = new MXWRegister(this.getPkgInfo.id, this.mxwRegisterUrl, this.mxwRegisterPath);
    this.mxwRegister.init();
    this.mxwRegister.onConnect = connected => {
      if (connected) {
        this.isConnected = true;
        // console.log('Max register socket connected');
        this.renderQrString();
      }
    };
    this.mxwRegister.onSignOn = data => {
      if (!this.isUndefinedOrNullOrEmpty(data)) {
        this.loginWithMaxWallet(JSON.stringify(data));
      }
    };

    this.mxwRegister.onSignUp = data => {
      if (!this.isUndefinedOrNullOrEmpty(data)) {
        if (this.pkgType === 'REGISTER') {
          this.registerWithMaxWallet(JSON.stringify(data));
        } else if (this.pkgType === 'GET_KYC') {
          const submitData = {
            userId: this.Getter_User_Info.id,
            data: JSON.stringify(data)
          };
          this.performKycWithMaxWallet(submitData);
        }
      }
    };

    this.mxwRegister.onError = error => {
      console.log('onError error', error);
    };
  },
  beforeDestroy() {
    this.mxwRegister.disconnect();
  }
};
</script>

<style lang="stylus" scoped>
@import "../../regist.scoped.styl";
@import "../../../common.styl";
.max-wrap {
  .v-card__title {
    padding: 10px 16px;
  }

  .v-card__text {
    color: #0c0c0c;
  }

  .btn-box {
    .v-btn::v-deep {
      flex: 1;
      padding: 0 10px;
      white-space: normal;

      .v-btn__content {
        flex: 1;
      }
    }
  }

  .mxw-wallet-benefit {
    background: #F5F5F8 0% 0% no-repeat padding-box;
    padding: 10px;
    margin-bottom: 15px;
  }

  .register-page {
    margin-top: 10px;
  }

  .mxw-wallet-benefit td {
    font-size: 14px;
  }

  .download-model {
    background: red;
    padding: 20px;
  }

  .bottom-section {
    background-color: #F5F5F8;
    min-height: 150px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    padding: 0px 20px;

    .img-step {
      max-width: 100px;
      width: 100%;
    }
  }
}
</style>
